module.exports = __webpack_public_path__ + "img/partner_14.3a67b840.png";